import React, { useContext, useEffect, useState } from 'react';
import { AppContext } from '../App';
import FirstTimeLoginModal from '../modals/FirstTimeLoginModal';
import { format, intervalToDuration, parseISO } from 'date-fns';
import useRemote from '../hooks/useRemote';
import UpgradeModal from '../modals/UpgradeModal';
import ThanksModal from '../modals/ThanksModal';
const UserDetails = ({setModal})=> {

	const [ name, setName ] = useState("");
	const [ upgrade, setUpgrade ] = useState(false);
	const app = useContext(AppContext);
	const remote = useRemote();

	const school = app.school;

	const logout = ()=> {
		remote.logout();
	}

	useEffect(()=>{
		const upgrade = 
			app.school.mathsLicense === "TRIAL" ||
			(app.school.mathsLicense === "TERM" && intervalToDuration({start: new Date(), end: app.school.mathsLicenseExpiry}).days <= 14) ||
			(app.school.mathsLicense === "PAGE" && app.school.mathsAvailableImpressions < 10);

		setUpgrade(upgrade);
	}, [ app.school.mathsLicense, app.school.mathsLicenseExpiry, app.school.mathsAvailableImpressions]);

	useEffect(()=>{
		const user = app.user;
		setName(user.substring(0, user.indexOf("@")));
	}, [ app.user, setName]);
	useEffect(()=>{
		if (app.firstLogin) {
			setModal(<FirstTimeLoginModal />)
		} else if (app.school.mathsLicense === "TRIAL") {

		}
	}, [ app.firstLogin, setModal, app.school.mathsLicense ]);

	const showUpgrade = ()=>{
		if (school.planRequested)
			return;
		
		setModal(<UpgradeModal onDone={()=>setModal(<ThanksModal />)} />)
	}
	return <div className="user-section">
		<div><strong>{school.name}</strong></div>
		<div className="license-details">
			{school.mathsLicense} Licence - {school.mathsLicenseExpiry ? 
				<>expires {format(parseISO(school.mathsLicenseExpiry), 'dd MMM yyyy')}</> : 
				<>{school.mathsAvailableImpressions} pages remaining</>
			}
			{upgrade && <div className="upgrade-button" onClick={showUpgrade}>{school.mathsLicense === "TRIAL" ? "UPGRADE" : "RENEW"}{school.planRequested && " IN PROGRESS"}</div>}
		</div>
		<div className="personal-details">Welcome, {name}<div className="log-out" onClick={logout}>(Log me out and forget about me)</div></div>
	</div>
}

export default UserDetails;